import React, { lazy } from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Del Chat al Pedido',
    subtitle: 'Sistema para No Perder Ventas en WhatsApp',
    desc: 'La Ficha de Pedido Relámpago, el Semáforo de Estados y los scripts exactos para confirmar cada pedido en 2 minutos, sin depender del chat como registro.',
    resuelve: 'Pedidos perdidos, datos incompletos, doble venta del mismo producto y separaciones sin seña.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Cobros y Señas',
    subtitle: 'Blindaje de Plata',
    desc: 'El protocolo completo para cobrar cada peso que te corresponde, sin incomodidad y sin errores. Verificá comprobantes y controlá saldos.',
    resuelve: 'Señas gastadas antes de tiempo, cobros no registrados, comprobantes falsos y saldos pendientes olvidados.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Stock A La Vista',
    subtitle: 'El Mapa de tu Inversión',
    desc: 'El sistema de inventario más simple y efectivo para emprendimientos chicos. Sabé exactamente qué tenés disponible, qué está reservado y qué no se mueve.',
    resuelve: 'Doble venta por descontrol, mercadería dormida que inmoviliza capital y reposición tardía.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Entregas Sin Caos',
    subtitle: 'Despacho Impecable',
    desc: 'El sistema de despacho que hace que cada pedido llegue correcto, completo y cobrado. Evitá errores de talle, color o dirección.',
    resuelve: 'Pedidos mezclados, despachos sin cobrar el saldo, entregas sin evidencia y retiros sin coordinar.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Cierre de Domingo',
    subtitle: 'Tu Plata Real',
    desc: 'El Cierre Semanal de 15 minutos: la herramienta que separa lo tuyo de lo comprometido, detecta fugas y te dice cuánto podés reinvertir y cuál es tu sueldo.',
    resuelve: 'No saber la ganancia real, gastos personales mezclados con el negocio y la sensación de trabajar para no saber qué queda.'
  }];
  const includes = ['Contenido práctico sin teoría innecesaria', 'Herramientas listas para usar desde hoy', 'Scripts y mensajes copiables para WhatsApp', 'Fichas, trackers, tablas y checklists listos para completar', 'Ejemplos reales de showrooms y revendedoras argentinas', 'Compatible con venta por WhatsApp, Instagram y estados', 'Diseño premium — funciona en celular o impreso'];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-286">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-287"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-288">
        <FadeIn data-id="element-289">
          <div className="text-center mb-16" data-id="element-290">
            <div className="inline-block bg-pink-500/10 text-pink-400 px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-pink-500/20 uppercase" data-id="element-291">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-4xl md:text-6xl text-white mb-4 tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-292">
              🏆 MÉTODO <span className="text-pink-400" data-id="element-293">CAJA ORDENADA™</span>
            </h2>
            <p className="text-lg md:text-xl font-sans font-medium opacity-90 text-[#FFFFFF] mb-8" data-id="element-294">
              5 Tomos + 4 Bonos · 125+ páginas · Todo resuelto.
            </p>
            <div className="max-w-3xl mx-auto text-gray-300 text-base md:text-lg font-sans leading-relaxed space-y-4" data-id="element-295">
              <p data-id="element-296">
                Método Caja Ordenada es un sistema práctico en PDF para
                revendedoras, dueñas de showroom y microemprendedoras que venden
                productos físicos por WhatsApp e Instagram en Argentina.
              </p>
              <p data-id="element-297">
                No es un libro de administración. No es contabilidad. No es
                gestión empresarial complicada.
              </p>
              <p className="text-white font-bold" data-id="element-298">
                Es el sistema operativo de tu negocio, listo para instalar en 48
                horas.
              </p>
              <p data-id="element-299">
                Cinco tomos que ordenan todo lo que pasa desde que una clienta
                te escribe "¿tenés en azul talle M?" hasta que el pedido está
                entregado, cobrado y registrado en tu caja semanal.
              </p>
            </div>
          </div>

          <div className="text-center mb-10" data-id="element-300">
            <h3 className="text-2xl md:text-4xl font-black text-white uppercase tracking-tight font-[Montserrat,_sans-serif]" data-id="element-301">
              Los 5 Tomos del Sistema
            </h3>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-20" data-id="element-302">
            <div className="lg:col-span-7 space-y-5" data-id="element-303">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-900/30 hover:bg-navy-900/50 transition-colors p-6 md:p-8 rounded-3xl border border-white/5 relative overflow-hidden group" data-id="element-304">
                  <div className="absolute left-0 top-0 w-1 h-full bg-pink-500/20 group-hover:bg-pink-500/50 transition-colors" data-id="element-305"></div>
                  <div className="flex items-start gap-5 md:gap-6" data-id="element-306">
                    <span className="text-3xl md:text-4xl shrink-0 mt-1 drop-shadow-sm" data-id="element-307">
                      {tomo.icon}
                    </span>
                    <div data-id="element-308">
                      <h3 className="text-lg md:text-xl font-sans font-black text-white leading-tight mb-1.5" data-id="element-309">
                        {tomo.title}
                      </h3>
                      <p className="text-pink-400 text-xs md:text-sm font-bold uppercase tracking-wider mb-3 font-sans" data-id="element-310">
                        {tomo.subtitle}
                      </p>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed font-sans mb-4" data-id="element-311">
                        {tomo.desc}
                      </p>
                      <div className="bg-navy-950/50 p-4 rounded-xl border border-white/5" data-id="element-312">
                        <span className="text-[10px] uppercase tracking-widest text-pink-400 font-bold block mb-2" data-id="element-313">
                          Lo que resuelve:
                        </span>
                        <ul className="text-xs text-gray-300 font-medium leading-relaxed list-disc pl-4 space-y-1" data-id="element-314">
                          {tomo.resuelve.split(', ').map((item, i) => <li key={i} data-id="element-315">
                              {item.charAt(0).toUpperCase() + item.slice(1)}
                            </li>)}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="lg:col-span-5 sticky top-24 hidden lg:block" data-id="element-316">
              <div className="relative w-full max-w-md mx-auto" data-id="element-317">
                <div className="absolute inset-0 bg-pink-500/10 blur-3xl rounded-full" data-id="element-318"></div>
                <img src="https://cdn.magicpatterns.com/uploads/vBukzSF3SWtGti7UtzBFwo/Mockup-Caja-Ordenada_(1).webp" alt="Método Caja Ordenada" className="relative z-10 w-full h-auto" width={400} height={400} loading="lazy" data-id="element-319" />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-320">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-pink-500/50 to-transparent" data-id="element-321" />
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full" data-id="element-322"></div>

            <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-12 font-[Montserrat,_sans-serif]" data-id="element-323">
              Cada Tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-324">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-4 bg-white/5 border border-white/5 p-5 rounded-2xl hover:bg-white/10 transition-colors" data-id="element-325">
                  <CheckCircle2 className="w-6 h-6 text-pink-400 flex-shrink-0" data-id="element-326" />
                  <span className="text-gray-100 font-medium text-sm md:text-base tracking-wide font-sans leading-snug" data-id="element-327">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};